// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetApiKeysRequestModel from '../../model/get-api-keys-request-model';
import GetApiKeysRequestDTO from '../dto/get-api-keys-request-dto';

export default abstract class GetApiKeysRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetApiKeysRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
      this.searchCriteria = data.searchCriteria;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  * @type {int64}
  */
  'userId'?: number;
  /**
  */
  'searchCriteria'?: string;
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<GetApiKeysRequestDTO>): GetApiKeysRequestModel;
  static toModel(dto: DeepPartial<GetApiKeysRequestDTO> | undefined | null): GetApiKeysRequestModel | undefined;
  static toModel(dto: DeepPartial<GetApiKeysRequestDTO> | undefined | null): GetApiKeysRequestModel | undefined {
    return dto ? new GetApiKeysRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetApiKeysRequestModel> | GetApiKeysRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'userId': unwrapped.userId,
      'searchCriteria': unwrapped.searchCriteria,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as GetApiKeysRequestDTO;
  }
}
